module.exports = __webpack_public_path__ + "img/customer-illustration.b5e8cc48.svg";